// eslint-disable-next-line import/prefer-default-export
export enum TopicStatus {
  Empty,
  Progress,
  Full,
}

export interface TopicsContainer {
  toolkitType: string;
  topics: Topic[];
}
export interface Topic {
  id: number;
  number: number;
  description: string;
  questions?: Question[];
  keywords?: Keyword[];
}
export interface Keyword {
  id: number;
  name: string;
}
export interface Question {
  id: number;
  number: number;
  description: string;
  footNote: string;
  options: ToolkitOption[];
  links: ToolkitLink[] | null;
  minValueAllowMultipleChoices: number;
  multipleChoices: ToolkitMultipleChoice[];
}
export interface ToolkitLink {
  code: string;
  url: string;
  name: string | null;
}
export interface ToolkitOption {
  id: number;
  text: string;
  value: number;
}

export interface AnswerMultipleChoice {
  id?: number | null;
  answerId?: number | null;
  multipleChoiceId?: number | null;
  comments?: string | null;
}

export interface MultipleChoiceWrapper {
  value: boolean;
  choice: AnswerMultipleChoice;
}

export interface Answer {
  id?: number | null;
  topicId: number;
  questionId: number;
  value: number;
  answerMultipleChoices: AnswerMultipleChoice[];
}

export interface ToolkitRequest {
  operationId: number;
  toolkitId: number | null;
  answers?: Answer[];
}

export interface ToolkitRationale {
  id: number;
  name: string;
}

export interface ImpactCategory {
  impactCategory: string;
  message: string;
  hasCompliance: boolean;
  toolkitRationales: ToolkitRationale[];
}

export interface DisasterRisk {
  disasterRisk: string;
  toolkitRationales: ToolkitRationale[];
}

export interface Esrr {
  esrr: string;
  toolkitRationales: ToolkitRationale[];
  changes: boolean;
  justification: string;
  lastCompass: boolean;
}

export interface ToolkitCalculatedValues {
  impactCategoryData: ImpactCategory;
  disasterRiskData: DisasterRisk;
  esrrData: Esrr;
  esps: string;
}

export interface DownloadToolkitRequest {
  documentType: string;
  toolkitId: number;
  language: string;
}

export interface ToolkitState {
  operationId: number;
  answers: Answer[];
}
export interface TopicState {
  id: number;
  Questions: QuestionState[];
}
export interface QuestionState {
  id: number;
  currentValue: string;
}

export interface Toolkit {
  id: number;
  createdBy: string;
  createdOn: string;
  modifiedBy: string;
  modifiedOn: string;
  pdfCreatedBy: string | null;
  version: number;
  impactCategory: string | null;
  impactCategoryCalculated: string;
  rationale: string | null;
  rationalComments: string | null;
  disasterRisk: string | null;
  disasterRiskCalculated: string;
  disasterRiskRationale: string | null;
  disasterRiskRationaleComments: string | null;
  // documentList: ToolkitDoc[];
  documentList: string[];
  esrr: string;
  esrrCalculated: string;
  esrrRationale: string | null;
  esrrRationaleComments: string | null;
  toolkitType: string;
  isDeleted: boolean;
  ezSPFCode: string;
  ezSSFCode: string;
  source: string;
}

export interface FinishToolkitState {
  operationId?: number;
  impactCategory: string;
  rational: number;
  comments: string;
  languages: string[];
  updateCompliance: boolean;

  disasterRisk: string;
  disasterRiskRationaleId?: number;
  disasterRiskComments: string;

  esrr: string;
  esrrRationaleId?: number;
  esrrComments: string;
}

export interface ToolkitMultipleChoice {
  id: number;
  text: string;
  commentsRequired: boolean;
}

export enum ToolkitTypes {
  FI = 'ESPF_FI',
  TCPO = 'ESPF_TCPO',
  LBR = 'ESPF_LBR',
  PBL = 'ESPF_PBL',
  ESPS = 'ESPF_ESPS',
  Classic = 'Classic',
}
